import * as React from 'react';

import classnames from 'classnames';

import {CaretUp, CaretDown} from '../icon';

import styles from './select-new.module.css';

type SelectProps = {
    selectValues: any[]; // Object, but we suck at flow,
    value: any; // Object, {normally {id: string, name: string},
    valueKey?: string;
    labelKey?: string;
    disabled?: boolean;
    onChange?: (...args: any) => any;
    isInline?: boolean;
    isTiny?: boolean;
};

export class SelectNew extends React.Component<SelectProps> {
    static displayName = 'SelectNew';
    selectInputRef: HTMLElement | null | undefined;

    static defaultProps = {
        value: {},
        labelKey: 'name',
        valueKey: 'id',
    };

    render() {
        const mappedSelectOptions = this.props.selectValues.map((option) => {
            return (
                <option
                    disabled={option.disabled}
                    // @ts-expect-error
                    key={option[this.props.valueKey]}
                    // @ts-expect-error
                    label={option[this.props.labelKey]}
                    // @ts-expect-error
                    value={option[this.props.valueKey]}
                >
                    {/* @ts-expect-error */}
                    {option[this.props.labelKey]}
                </option>
            );
        });

        const containerStyle = classnames(styles.container, {
            // @ts-expect-error
            [styles['container-disabled']]: this.props.disabled,
            [styles['container--inline']]: this.props.isInline,
        });

        const selectStyle = classnames(styles.select, {
            [styles['select--tiny']]: this.props.isTiny,
        });

        const arrowUpStyle = classnames(styles.arrowUp, {
            [styles['arrowUp--tiny']]: this.props.isTiny,
        });

        const arrowDownStyle = classnames(styles.arrowDown, {
            [styles['arrowDown--tiny']]: this.props.isTiny,
        });

        // @ts-expect-error
        const selectValue = this.props.value[this.props.valueKey] || '';

        return (
            <div className={containerStyle}>
                <div className={styles['select-container']}>
                    <select
                        disabled={this.props.disabled}
                        value={selectValue}
                        ref={(node) => {
                            this.selectInputRef = node;
                        }}
                        onChange={this.handleChange}
                        className={selectStyle}
                    >
                        {mappedSelectOptions}
                    </select>
                    <CaretUp className={arrowUpStyle} />
                    <CaretDown className={arrowDownStyle} />
                </div>
            </div>
        );
    }

    handleChange = (e: {
        target: {
            value: string;
        };
    }) => {
        const newValue = this.props.selectValues.find((val) => {
            // @ts-expect-error
            return String(val[this.props.valueKey]) === e.target.value;
        });

        if (typeof this.props.onChange === 'function') {
            this.props.onChange(newValue);
        }
    };
}
